// extracted by mini-css-extract-plugin
module.exports = {"ArticlePicture":"ArticlePicture_ArticlePicture__8jfri","ArticlePicture_caption":"ArticlePicture_ArticlePicture_caption__31mpf"};